import { CheckCircleOutlined } from "@mui/icons-material";

const CheckCircle = ({ fontSize = "30px" }) => {
  return <CheckCircleOutlined sx={{ fontSize: fontSize }} />;
};

export default CheckCircle;
